export default "__VITE_PUBLIC_ASSET__0e9e4438__"